module.exports = __webpack_public_path__ + "static/image/logo-family/logo_taste@2x.png?20af29ec";